import React from "react";

export default function DesktopIconsPanel({ projects, onOpenProjectWindow }) {
  return (
    <aside className="desktopIcons">
      {projects.map((project) => (
        <button
          key={project.id}
          className="desktopIcon"
          onClick={() => onOpenProjectWindow(project.id)}
          type="button"
        >
          <span
            className={`desktopIconBadge ${project.mockTheme} ${
              project.id === "petinga" ? "desktopIconBadgePetinga" : ""
            }`}
          >
            {project.icon}
          </span>
          <span>{project.name}</span>
        </button>
      ))}
    </aside>
  );
}
